<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import Close from './Close.svelte'
  import Reset from './Reset.svelte'

  const dispatch = createEventDispatcher()
  const onClickClose = () => dispatch('close')
  const onClickReset = () => dispatch('reset')
</script>

<div class="flex flex-shrink-0 items-center justify-between p-4">
  <Reset on:click={onClickReset} />
  <Close on:click={onClickClose} />
</div>
